import React from 'react';
import FormMassActionsContainer from './components/FormMassActions.container';

const Form = ({ history }) => {
  return <FormMassActionsContainer history={history} />;
};

export default Form;
